import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

export const dashboardAPI = createApi({
  reducerPath: 'dashboard',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // Consumer dashboard loan summary
    getApplicationDashboardInfo: builder.query({
      query: (applicationId) => {
        return {
          url: `b2c/loan/dashboard/loan_info/${applicationId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
  }),
});

export const { useGetApplicationDashboardInfoQuery } = dashboardAPI;
